// extracted by mini-css-extract-plugin
export default {"statisticsHeader":"statisticsheader_statisticsHeader__HWb1l","title":"statisticsheader_title__GSdyw"};